export default "__VITE_ASSET__Bc7xuqAg__"